import {Directive, ElementRef, HostListener} from '@angular/core';
import {constants} from "../../constants";

@Directive({
  selector: 'img[appReplaceMissingImage]'
})
export class ReplaceMissingImageDirective {
  constructor(private el: ElementRef) {}

  @HostListener("error")
  private onError() {
    (this.el.nativeElement as HTMLImageElement).src = constants.defaultImage;
  }
}
